import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Col, Menu, message } from 'antd';
import { ClickParam } from 'antd/lib/menu';
import { History } from 'history';
import { FaSignOutAlt } from 'react-icons/fa';
import { IoMdLock } from 'react-icons/io';
import i18n from 'i18next';

import { getUserState } from '../../store/user/selector';
import { logoutuser } from '../../store/user/actions';
import { SettingsRouteProps } from './Settings';
import { colors } from '../../constants/colors';

import LogoIcon from '../../assets/images/png/user.png';

interface DetailsProps {
  title: string;
  detail?: string;
}

export const DetailsBlock: React.FC<DetailsProps> = ({ title, detail }) => {
  return (
    <Col className="account-details-block">
      <div className="title">{title}</div>
      <div className="description">{detail}</div>
    </Col>
  );
};

export const MyAccount: React.FC<SettingsRouteProps> = ({ setHeaderTitle }) => {
  const { user, providername } = useSelector(getUserState);
  const dispatch = useDispatch();
  const history: History = useHistory();

  const setHeader: React.EffectCallback = () => {
    if (setHeaderTitle) setHeaderTitle('My Account');
  };

  const handleMenuClick = (e: ClickParam): void => {
    const googleChangePasswordUrl =
      'https://support.google.com/accounts/answer/41078?co=GENIE.Platform%3DDesktop&hl=en';
    const fbChangePasswordUrl =
      'https://www.facebook.com/settings?tab=security&section=password&view';
    switch (e.key) {
      case 'logout':
        dispatch(logoutuser());
        message.info('Logged out');
        history.push('/');
        break;
      case 'password':
        if (providername === 'google.com' || providername === 'facebook.com') {
          if (
            window.confirm(
              'Changing your password as you currently signed into google or fb account, you will be automatically logout are you sure to continue?'
            )
          ) {
            if (
              providername === 'google.com' ||
              providername === 'facebook.com'
            ) {
              window.open(
                providername === 'google.com'
                  ? googleChangePasswordUrl
                  : fbChangePasswordUrl,
                '_blank'
              );
            }
            dispatch(logoutuser());
            message.info('Logged out');
            history.push('/');
          }

          return;
        }
        history.push('/settings/changepassword');
        break;
      default:
    }
  };

  useEffect(setHeader, [setHeaderTitle]);
  return (
    <React.Fragment>
      <Col className="about-us-block margin-top">
        <img src={LogoIcon} alt="" />
      </Col>
      <Col className="account-details">
        <DetailsBlock title={i18n.t('NAME')} detail={user.firstName} />
        <DetailsBlock title={i18n.t('SURNAME')} detail={user.lastName} />
        <DetailsBlock title="E-mail" detail={user.email} />
      </Col>
      <Col className="account-details">
        <Menu
          selectable={false}
          mode="vertical"
          className="profile-menu-container margin-top"
          onClick={handleMenuClick}
        >
          <Menu.Divider className="profile-menu-divider" />
          <Menu.Item key="password">
            <IoMdLock color={colors.iconColor} size={21} />
            <span>{i18n.t('CHANGE_PASSWORD')}</span>
          </Menu.Item>
          <Menu.Divider className="profile-menu-divider" />
          <Menu.Item key="logout">
            <FaSignOutAlt color={colors.iconColor} size={18} />
            <span>{i18n.t('Sign out')}</span>
          </Menu.Item>
        </Menu>
      </Col>
    </React.Fragment>
  );
};
